import React from 'react';
import Chip from '@material-ui/core/Chip';

export const EstablishmentPlanBadge = ({ plan }) =>  {
  const className = plan ? `${plan.toLowerCase()}-badge-class` : 'base-badge-class';
  return (
  <>
    <Chip className={className} label={plan} variant={plan === 'Base' ? 'outlined' : 'default'}></Chip>
  </>
  );
};
